var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"imgUpload"}},[_c('el-upload',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"action":_vm.action,"headers":{ ['Authorization']: 'Bearer ' + _vm.token },"show-file-list":false,"before-upload":() => {
        _vm.loading = true;
      },"on-error":() => {
        _vm.loading = false;
      },"on-success":_vm.handleSuccess}},[(_vm.previewUrl)?_c('img',{key:_vm.previewUrl,staticClass:"avatar",attrs:{"src":_vm.previewUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }